import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function EmailsArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const emails = control.value as string[]; // Ensure the control value is an array of strings
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/; // Simple email pattern

        if (!Array.isArray(emails)) {
            return { invalidFormat: true };
        }

        const invalidEmails = emails.filter(email => !emailPattern.test(email));

        return invalidEmails.length > 0
            ? { invalidEmails: invalidEmails } // Return the invalid emails
            : null; // No validation errors
    };
}
